import { Box } from '@rbilabs/universal-components';

export const Wrapper = Box.withConfig({
  paddingY: '$4',
  borderTopWidth: 1,
  borderTopColor: 'black',

  _text: {
    fontSize: '2xs',
  },
});
